import { render, staticRenderFns } from "./cardsArray.vue?vue&type=template&id=459ac8fc&scoped=true"
import script from "./cardsArray.vue?vue&type=script&lang=js"
export * from "./cardsArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459ac8fc",
  null
  
)

export default component.exports